import gql from 'graphql-tag';
import { summaryFragment } from '../fragments/summary';
import { footballStatFragment } from '../../../gql/fragments/FootballStats';
import { rugbyLeagueStatFragment } from '../../../gql/fragments/RugbyLeagueStats';
import { rugbyUnionStatFragment } from '../../../gql/fragments/RugbyUnionStats';
export const matchSummaryQuery = gql `
  query matchSummary($matchId: Float!) {
    matchSummary(matchId: $matchId) {
      ...Summary
    }
  }
  ${summaryFragment}
  ${footballStatFragment}
  ${rugbyUnionStatFragment}
  ${rugbyLeagueStatFragment}
`;
//# sourceMappingURL=summary.js.map